module.exports = __webpack_public_path__ + "img/exclamatory_mark.43800a78.png";